import { ChevronLeft, ChevronRight, Pause, Play, RotateCcw } from "./icons";

interface PlaybackControlsProps {
  playing: boolean;
  current: number;
  total: number;
  speed: number;
  onToggle: () => void;
  onPrevious: () => void;
  onNext: () => void;
  onReplay: () => void;
  onSpeed: (speed: number) => void;
}

export function PlaybackControls({ playing, current, total, speed, onToggle, onPrevious, onNext, onReplay, onSpeed }: PlaybackControlsProps) {
  return (
    <div className="playback-controls">
      <button className="icon-button" onClick={onReplay} aria-label="重播"><RotateCcw size={18} /></button>
      <button className="icon-button" onClick={onPrevious} disabled={current === 0} aria-label="上一步"><ChevronLeft size={20} /></button>
      <button className="play-button" onClick={onToggle} aria-label={playing ? "暂停" : "播放"}>
        {playing ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" />}
      </button>
      <button className="icon-button" onClick={onNext} disabled={current >= total - 1} aria-label="下一步"><ChevronRight size={20} /></button>
      <span className="step-counter">{current + 1} / {total}</span>
      <select value={speed} onChange={(event) => onSpeed(Number(event.target.value))} aria-label="播放倍速">
        <option value={0.5}>0.5×</option>
        <option value={1}>1×</option>
        <option value={1.5}>1.5×</option>
        <option value={2}>2×</option>
      </select>
    </div>
  );
}
